import React from 'react';
import { useCustomComponent } from '@/hooks';

const CloseIconComponent: React.FC = () => {
  return <span className="peptalk-widget-button-close">×</span>;
};

export const CloseIcon: React.FC = () => {
  const Component = useCustomComponent({
    componentName: 'WidgetButtonCloseIcon',
    Component: CloseIconComponent,
  });

  return <Component />;
};
